export const professionalQuestions = [
  {
    questionNumber: 1,
    choices: {
      A: "A man is writing on a board.",
      B: "Some people are looking at their phones.",
      C: "A woman is holding a marker.",
      D: "A laptop has been placed on the desk.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 여자가 마커를 손에 쥐고 있음\n" +
      "오답 설명: (A) 남자가 아닌 여자가 있음, (B) 휴대폰을 보고 있지 않음, (D) 노트북이 사용 중임",
  },
  {
    questionNumber: 2,
    choices: {
      A: "A woman is writing on the whiteboard.",
      B: "A woman is holding a cup.",
      C: "People are standing around a table.",
      D: "A man is giving a presentation in front of a group.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 컵을 들고 있음\n" +
      "오답 설명: (A) 화이트보드에 쓰지 않음, (C) 사람들이 서있지 않음, (D) 발표하는 사람이 없음",
  },
  {
    questionNumber: 3,
    choices: {
      A: "A woman is standing at a podium.",
      B: "A woman is using a laptop.",
      C: "A man is pointing at a whiteboard.",
      D: "A woman is leaning over a table.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 여자가 테이블 위로 몸을 기울이고 있음\n" +
      "오답 설명: (A) 강연대가 없음, (B) 노트북을 사용하지 않음, (C) 화이트보드를 가리키는 남자가 없음",
  },
  {
    questionNumber: 4,
    choices: {
      A: "A man is pointing at a laptop screen.",
      B: "A group of people is having a meal together.",
      C: "A woman is writing notes in a notebook.",
      D: "Some people are standing in front of a whiteboard.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 노트북 화면을 가리키고 있음\n" +
      "오답 설명: (B) 식사를 하고 있지 않음, (C) 노트에 필기하지 않음, (D) 화이트보드 앞에 서있지 않음",
    imageUrl: "/images/part1/people/professional/professional4.png",
    audioUrl: "/audios/part1/people/professional/professional4.mp3",
  },
  {
    questionNumber: 5,
    choices: {
      A: "Some people are having a meeting in a conference room.",
      B: "A man is giving a presentation in front of a projector.",
      C: "Some people are standing near a whiteboard.",
      D: "A woman is handing out documents to her colleagues.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 사람들이 회의실에서 회의를 하고 있음\n" +
      "오답 설명: (B) 프로젝터 앞에서 발표하지 않음, (C) 화이트보드 근처에 서있지 않음, (D) 문서를 나눠주지 않음",
  },
  {
    questionNumber: 6,
    choices: {
      A: "A woman is leaning over a desk and writing.",
      B: "Some people are reviewing documents.",
      C: "A man is sitting with his arms crossed.",
      D: "A man is resting his arm on a shelf.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 남자가 선반에 팔을 기대고 있음\n" +
      "오답 설명: (A) 책상에 기대어 쓰고 있지 않음, (B) 문서를 검토하지 않음, (C) 팔짱을 끼고 있지 않음",
    imageUrl: "/images/part1/people/professional/professional6.png",
    audioUrl: "/audios/part1/people/professional/professional6.mp3",
  },
  {
    questionNumber: 7,
    choices: {
      A: "Some people are shaking hands.",
      B: "Some people are putting their hands together.",
      C: "A group of people is sitting in a circle.",
      D: "Some people are clapping their hands.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 사람들이 손을 모으고 있음\n" +
      "오답 설명: (A) 악수하지 않음, (C) 원형으로 앉아있지 않음, (D) 박수를 치지 않음",
  },
  {
    questionNumber: 8,
    choices: {
      A: "A group of people is eating lunch together.",
      B: "A man is pointing at a diagram.",
      C: "A man is moving a chair.",
      D: "A graph has been drawn.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 그래프가 그려져 있음\n" +
      "오답 설명: (A) 점심을 먹고 있지 않음, (B) 다이어그램을 가리키지 않음, (C) 의자를 옮기지 않음",
  },

  {
    questionNumber: 9,
    choices: {
      A: "A woman is making a phone call.",
      B: "Some people are working on their laptops.",
      C: "A man is presenting a report to his colleagues.",
      D: "Some people are having a meal together.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 사람들이 함께 식사를 하고 있음\n" +
      "오답 설명: (A) 전화하는 사람이 없음, (B) 노트북을 사용하지 않음, (C) 보고를 하지 않음",
  },
  {
    questionNumber: 10,
    choices: {
      A: "Some people are assembled for a meeting.",
      B: "Some people are eating lunch at the table.",
      C: "A woman is writing down notes on a notepad.",
      D: "A graph is being drawn.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여러 사람이 회의를 위해 모여 있음\n" +
      "오답 설명: (B) 식사를 하지 않음, (C) 노트에 필기하지 않음, (D) 그래프를 그리지 않음",
  },

  {
    questionNumber: 11,
    choices: {
      A: "A woman is holding a phone.",
      B: "Some people are wearing headsets.",
      C: "A woman is putting on headphones.",
      D: "A man is pointing at a screen.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 사람들이 헤드셋을 착용하고 있음\n" +
      "오답 설명: (A) 전화기를 들고 있지 않음, (C) 이미 헤드폰을 착용한 상태임, (D) 화면을 가리키지 않음",
  },

  {
    questionNumber: 12,
    choices: {
      A: "A man and a woman are waving at a screen.",
      B: "Some people are working in a warehouse.",
      C: "A man is giving a handshake.",
      D: "A man is typing on a keyboard.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자와 여자가 화면을 향해 손을 흔들고 있음\n" +
      "오답 설명: (B) 창고가 아닌 사무실임, (C) 악수하지 않음, (D) 키보드로 타이핑하지 않음",
  },
  {
    questionNumber: 13,
    choices: {
      A: "A man and a woman are sitting side by side.",
      B: "A group of people is having a discussion.",
      C: "A woman is writing on a notepad.",
      D: "A man is pointing at a monitor.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자와 여자가 나란히 앉아있음\n" +
      "오답 설명: (B) 그룹이 아닌 두 명임, (C) 노트패드에 쓰지 않음, (D) 모니터를 가리키지 않음",
  },
  {
    questionNumber: 14,
    choices: {
      A: "A woman is drinking coffee.",
      B: "A man and a woman are sitting face to face.",
      C: "A man is presenting a graph.",
      D: "A woman is typing on a keyboard.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자와 여자가 서로 마주보고 앉아있음\n" +
      "오답 설명: (A) 커피를 마시지 않음, (C) 그래프를 발표하지 않음, (D) 키보드로 타이핑하지 않음",
  },

  {
    questionNumber: 15,
    choices: {
      A: "A man is distributing paperwork.",
      B: "A man is adjusting a projector.",
      C: "A man is signing an agreement.",
      D: "A man is drinking from a glass.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 서류를 나눠주고 있음\n" +
      "오답 설명: (B) 프로젝터가 없음, (C) 서명하지 않음, (D) 음료를 마시지 않음",
  },
  {
    questionNumber: 16,
    choices: {
      A: "A woman is handing out documents.",
      B: "A woman is adjusting a projector.",
      C: "A woman is signing an agreement.",
      D: "A woman is drinking from a glass.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 서류를 나눠주고 있음\n" +
      "오답 설명: (B) 프로젝터가 없음, (C) 서명하지 않음, (D) 물을 마시지 않음",
  },

  {
    questionNumber: 17,
    choices: {
      A: "A woman is reviewing a printed document.",
      B: "A woman is taking paper out of a printer.",
      C: "A woman is handing a file to a colleague.",
      D: "A woman is shredding paper.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 출력된 문서를 검토하고 있음\n" +
      "오답 설명: (B) 프린터에서 종이를 꺼내지 않음, (C) 파일을 전달하지 않음, (D) 종이를 파쇄하지 않음",
  },
  {
    questionNumber: 18,
    choices: {
      A: "A woman is operating a photocopier.",
      B: "A woman is loading paper into a printer.",
      C: "Paper is being printed.",
      D: "A printer is being repaired.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 복사기를 작동하고 있음\n" +
      "오답 설명: (B) 프린터에 종이를 넣지 않음, (C) 종이가 프린트되고 있지 않음, (D) 프린터를 수리하지 않음",
  },
  {
    questionNumber: 19,
    choices: {
      A: "A printer lid is open.",
      B: "A woman is replacing ink in a printer.",
      C: "A woman is reviewing documents.",
      D: "A woman is opening a printer cover.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 프린터 뚜껑이 열려있음\n" +
      "오답 설명: (B) 잉크를 교체하지 않음, (C) 문서를 검토하지 않음, (D) 프린터 뚜껑을 열고 있지 않음",
  },
  {
    questionNumber: 20,
    choices: {
      A: "A woman is holding the lid of a copier.",
      B: "A woman is pressing a button on a machine.",
      C: "A woman is organizing some files.",
      D: "A woman is replacing a toner cartridge.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 복사기 뚜껑을 잡고 있음\n" +
      "오답 설명: (B) 버튼을 누르지 않음, (C) 파일을 정리하지 않음, (D) 토너를 교체하지 않음",
  },
  {
    questionNumber: 21,
    choices: {
      A: "The man is resting his arm on the counter.",
      B: "A man is sitting on a stool.",
      C: "A man is writing on a clipboard.",
      D: "Blinds are covering the window.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 카운터에 팔을 기대고 있음\n" +
      "오답 설명: (B) 스툴에 앉아있지 않음, (C) 클립보드에 쓰지 않음, (D) 블라인드가 창문을 가리지 않음",
  },

  {
    questionNumber: 22,
    choices: {
      A: "A man is pointing at a document.",
      B: "A man is signing an agreement.",
      C: "A woman is handing a pen to a man.",
      D: "A man and a woman are seated next to each other.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 문서를 가리키고 있음\n" +
      "오답 설명: (B) 서명하지 않음, (C) 펜을 건네주지 않음, (D) 나란히 앉아있지 않음",
  },
  {
    questionNumber: 23,
    choices: {
      A: "A drawer is open.",
      B: "A man is flipping through a document.",
      C: "A man is closing a drawer.",
      D: "A man is stacking books on a shelf.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 서랍이 열려져 있음\n" +
      "오답 설명: (B) 문서를 넘기지 않음, (C) 서랍을 닫지 않음, (D) 책을 쌓지 않음",
  },
  {
    questionNumber: 24,
    choices: {
      A: "A man is carrying several binders.",
      B: "A man is filing some documents.",
      C: "A man is opening a folder.",
      D: "A man is placing books on a shelf.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 남자가 여러 개의 바인더를 들고 있음\n" +
      "오답 설명: (B) 서류를 정리하지 않음, (C) 폴더를 열지 않음, (D) 책을 꽂지 않음",
  },

  {
    questionNumber: 25,
    choices: {
      A: "The man is placing a binder on the shelf.",
      B: "A man is flipping through the pages of a file.",
      C: "The man is picking up a binder from the shelf.",
      D: "A man is writing something in a notebook.",
    },
    incorrectAnswers: ["A", "B", "D"],
    explanation:
      "정답 설명: (C) 남자가 선반에서 바인더를 꺼내고 있음\n" +
      "오답 설명: (A) 바인더를 선반에 놓지 않음, (B) 파일을 넘겨보지 않음, (D) 노트에 글을 쓰지 않음",
  },
  {
    questionNumber: 26,
    choices: {
      A: "A woman is examining a document.",
      B: "A woman is typing on a laptop.",
      C: "A woman is putting papers into a folder.",
      D: "A woman is highlighting text in a notebook.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 문서를 검토하고 있음\n" +
      "오답 설명: (B) 노트북을 사용하지 않음, (C) 폴더에 서류를 넣지 않음, (D) 형광펜으로 표시하지 않음",
  },

  {
    questionNumber: 27,
    choices: {
      A: "A woman is resting her chin on her hand.",
      B: "A woman is taking notes in a planner.",
      C: "A woman is adjusting her glasses.",
      D: "A woman is talking on the phone.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 여자가 턱을 손으로 괴고 있음\n" +
      "오답 설명: (B) 플래너에 필기하지 않음, (C) 안경을 만지지 않음, (D) 전화통화를 하지 않음",
    imageUrl: "/images/part1/people/professional/professional49.png",
    audioUrl: "/audios/part1/people/professional/professional49.mp3",
  },

  {
    questionNumber: 28,
    choices: {
      A: "The people are sitting in a circle.",
      B: "A woman is giving a presentation at a podium.",
      C: "The group is having a meal together.",
      D: "Some people are working on their laptops.",
    },
    incorrectAnswers: ["B", "C", "D"],
    explanation:
      "정답 설명: (A) 사람들이 원형으로 앉아있음\n" +
      "오답 설명: (B) 연단에서 발표하지 않음, (C) 식사를 하지 않음, (D) 노트북을 사용하지 않음",
  },
  {
    questionNumber: 29,
    choices: {
      A: "The man is buttoning his jacket.",
      B: "The man is rolling up his sleeves.",
      C: "The businessman is talking on the phone.",
      D: "The man is putting on a watch.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 남자가 소매를 걷고 있음\n" +
      "오답 설명: (A) 재킷 단추를 잠그지 않음, (C) 전화통화를 하지 않음, (D) 시계를 착용하지 않음",
  },
  {
    questionNumber: 30,
    choices: {
      A: "The group is walking through the office.",
      B: "The woman is writing on the whiteboard.",
      C: "The colleagues are shaking hands.",
      D: "The people are listening to the speaker.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 사람들이 연사의 말을 듣고 있음\n" +
      "오답 설명: (A) 사무실을 걷고 있지 않음, (B) 화이트보드에 쓰고 있지 않음, (C) 악수하고 있지 않음",
  },
  {
    questionNumber: 31,
    choices: {
      A: "The people are entering the elevator.",
      B: "The woman is standing inside the elevator.",
      C: "The elevator doors are closing.",
      D: "The people are stepping out of the elevator.",
    },
    incorrectAnswers: ["A", "B", "C"],
    explanation:
      "정답 설명: (D) 사람들이 엘리베이터에서 나오고 있음\n" +
      "오답 설명: (A) 엘리베이터에 들어가고 있지 않음, (B) 엘리베이터 안에 서있지 않음, (C) 엘리베이터 문이 닫히고 있지 않음",
  },
  {
    questionNumber: 32,
    choices: {
      A: "The woman is typing on a laptop.",
      B: "A woman is raising her hand.",
      C: "The people are walking out of the room.",
      D: "The woman is drinking coffee.",
    },
    incorrectAnswers: ["A", "C", "D"],
    explanation:
      "정답 설명: (B) 여자가 손을 들고 있음\n" +
      "오답 설명: (A) 노트북에 타이핑하고 있지 않음, (C) 사람들이 방에서 나가고 있지 않음, (D) 커피를 마시고 있지 않음",
  },
];
